import React from 'react';

/**
 * Compose utility for composing providers
 * Transforms an array of providers into a single composition without deep nesting
 */
interface ProviderConfig {
  Provider: React.FC<any>;
  props?: any;
}

export const composeProviders = ( providers: ProviderConfig[] ): React.FC<{ children: React.ReactNode }> => {
  return ( { children } ) => {
    return providers.reduceRight( ( acc, { Provider, props = {} } ) => {
      return <Provider { ...props }>{ acc }</Provider>;
    }, children as React.ReactElement );
  };
};
